import React from 'react';
import { Marker } from 'react-google-maps';
import HotelInfoWindow from './MapInfoWindow';
import DisabledIcon from 'assets/images/LocationGrey.png';
import RedLocationIcon from 'assets/images/LocationRed.png';

const HotelMapMarkerCluster = props => {
  let locationArray = [];
  const { isOpen, markerIndex, marinas, infoWindowToggle } = props;
  
  for (const marina of marinas) {
    const { id, geo_location, name, images, city, country, marina_settings } = marina;
    if (!geo_location) continue;
    let marinaLocation = {};

    marinaLocation = {
      id,
      lat: parseFloat(geo_location.lat),
      lng: parseFloat(geo_location.lng),
      formattedAddress: `${city}, ${country}`,
      title: name,
      thumbUrl: images && images.length ? images[0].thumb : null,
      disabled: !marina_settings?.permissions.reservation,
    };

    locationArray.push(marinaLocation);
  }

  return locationArray.map((singlePostLoaction, index) => {
    return (
      <Marker
        key={index}
        position={singlePostLoaction}
        clickable={true}
        onClick={() => {
          infoWindowToggle(singlePostLoaction.id);
        }}
        icon={singlePostLoaction.disabled ? {url: DisabledIcon} : {url: RedLocationIcon}}
      >
        {isOpen && markerIndex === singlePostLoaction.id ? (
          <HotelInfoWindow
            onCloseClick={() => {
              infoWindowToggle(singlePostLoaction.id);
            }}
            postData={singlePostLoaction}
          />
        ) : (
          ''
        )}
      </Marker>
    );
  });
};

export default HotelMapMarkerCluster;
